// extracted by mini-css-extract-plugin
module.exports = {"root":"Work-module__root___3mW5h","noPointer":"Work-module__noPointer___1XeSz"};